let efimovLandingHosts = {
    //local: 'https://kubernetes.docker.internal/api/',
    local: 'http://localhost:8200/api/',
    prod: 'https://conference.vavt.ru/api/',
};

let currentHost = efimovLandingHosts[process.env.VUE_APP_DEPLOYMENT_ENV];

export { currentHost };